import {PartnerAdmin} from "@/models/PartnerAdminModel";
import {EMPTY_GUID} from "@/utils/GuidUtil";

export class Partner {
    id = EMPTY_GUID;
    name = '';
    customId = '';
    admins = [] as PartnerAdmin[];
}